import React from 'react';
import '../Css/Course.css';


function MasterBanner() {
  return (
   <div className="Course-Wrapper">
        <div className="Course-Content">
            <div className="Course-Body-Context">
                <img src={require('../Image/HREApp-Master.png')} style={{width:'600px',height:'95px'}} alt="家居水電維修"/>
            </div>        
        </div>
    </div>
  );

}

export default MasterBanner
